<template>
  <dialog :open="isOpen" class="modal">
    <div class="modal-box">
      <h3 class="font-bold text-lg mb-4">Edit Edge Condition</h3>

      <form @submit.prevent="saveChanges">
        <div class="form-control mb-4">
          <label class="label">
            <span class="label-text">Condition Prompt (leave empty for unconditional flow)</span>
          </label>
          <input
            type="text"
            v-model="editableCondition"
            class="input input-bordered w-full"
            placeholder="e.g., user input contains yes"
          />
        </div>

        <div class="modal-action">
          <button type="button" class="btn btn-error" style="background-color: var(--fallback-er,oklch(var(--er)/1));" @click="deleteEdge">Delete Connection</button>
          <button type="button" class="btn" @click="closeModal">Cancel</button>
          <button type="submit" class="btn">Save Condition</button>
        </div>
      </form>
    </div>
    <form method="dialog" class="modal-backdrop">
      <button @click="closeModal">close</button>
    </form>
  </dialog>
</template>

<script setup>
import { ref, watch } from 'vue';

const props = defineProps({
  isOpen: {
    type: Boolean,
    required: true
  },
  condition: {
    type: String,
    default: ''
  }
});

const emit = defineEmits(['close', 'save', 'delete-edge']);

const editableCondition = ref('');

watch(() => props.condition, (newCondition) => {
  editableCondition.value = newCondition !== undefined && newCondition !== null && newCondition !== '' ? newCondition : '';
}, { immediate: true });

function closeModal() {
  emit('close');
}

function saveChanges() {
  emit('save', editableCondition.value);
  closeModal();
}

function deleteEdge() {
  emit('delete-edge');
  closeModal();
}
</script>

<style scoped>

</style>